import { render, staticRenderFns } from "./faq_node.vue?vue&type=template&id=4c608793&scoped=true&"
import script from "./faq_node.vue?vue&type=script&lang=js&"
export * from "./faq_node.vue?vue&type=script&lang=js&"
import style0 from "./faq_node.vue?vue&type=style&index=0&id=4c608793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c608793",
  null
  
)

export default component.exports